export const FormatToLocalCurrency = (number, countryCode = 'US', languageCode = 'en', currencyCode = 'USD') => {
  let formatter = new Intl.NumberFormat(`${languageCode}-${countryCode}`, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2, 
  });
  return formatter.format(number);
};
